/* Render React */
import { createRoot } from 'react-dom/client';

/* Main app component */
import App from './App';

/* Global CSS styles */
import '@travelbuddy/design-tokens/tokens.css';
import './styles/global.css';

/* Error boundaries will catch any render errors and prevent the app from crashing */
import ErrorBoundary from './components/ErrorBoundary';

/* Mount the app to the DOM */
const container = document.getElementById('root');

/* Create a React root */
const root = createRoot(container);

/* Render the app */
root.render(
    <ErrorBoundary>
        <App />
    </ErrorBoundary>
);
